import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Header, Footer } from '../Common';
import HeroBanner from '@ajat/design-system/ContentBlocks/HeroBanner';
import Input from '@ajat/design-system/Input';
import Button from '@ajat/design-system/Button';
import { STUDENT_CLUBS } from './studentClubData';
import '../../Common/StudentClub/StudentClub.css';

/* ══════════════════════════════════════════════════════════════════════════
 * CLS-DK — Student Club entry page
 * Uses the CLS-DK Landing hero-block styling (light theme, gray-1 bg,
 * `hero-studietur.jpg` visual, green `alternative` CTA variant). The default
 * HeroBanner CTA is replaced by a searchable club dropdown + conditional
 * password field, submitted via contentSlot.
 * ══════════════════════════════════════════════════════════════════════════ */
const StudentClub = () => {
  const navigate = useNavigate();
  const [selectedClub, setSelectedClub] = useState(null);
  const [clubQuery, setClubQuery]       = useState('');
  const [password, setPassword]         = useState('');

  /* Set global brand on mount, restore previous on unmount */
  useEffect(() => {
    const prev = document.documentElement.getAttribute('data-brand');
    document.documentElement.setAttribute('data-brand', 'CLS');
    return () => {
      if (prev) document.documentElement.setAttribute('data-brand', prev);
      else document.documentElement.removeAttribute('data-brand');
    };
  }, []);

  const clubOptions = STUDENT_CLUBS.map((c) => ({
    label: c.name,
    value: c.slug,
  }));

  const handleClubSelect = (option) => {
    if (!option) {
      setSelectedClub(null);
      setPassword('');
      return;
    }
    const club = STUDENT_CLUBS.find((c) => c.slug === option.value) || null;
    setSelectedClub(club);
    setClubQuery(option.label);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedClub || !password.trim()) return;
    navigate(`/clothing/cls-dk/student-club/${selectedClub.slug}`);
  };

  const heroForm = (
    <form className="student-club-form" onSubmit={handleSubmit} noValidate>
      <div className="student-club-form__inputs">
        <Input
          type="searchable"
          label="Skriv navnet på din studenterklub"
          value={clubQuery}
          onChange={(e) => setClubQuery(e.target.value)}
          options={clubOptions}
          onSelect={handleClubSelect}
          showOptionIcons={false}
        />

        {selectedClub && (
          <div className="student-club-form__password">
            <Input
              type="password"
              label="Adgangskode"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        )}
      </div>

      <div className="student-club-form__submit-row">
        <Button
          type="submit"
          size="primary"
          variant="alternative"
          iconRight={<ArrowRight />}
          disabled={!selectedClub || !password.trim()}
        >
          Fortsæt
        </Button>
      </div>
    </form>
  );

  return (
    <div className="student-club">
      <Header />

      <HeroBanner
        subtitle="LOGIN TIL DIN STUDENTERKLUB"
        title="Vælg din studenterklub"
        image={require('../../../../assets/cls-dk/landing/hero-studietur.jpg')}
        imageAlt="Studenterklub"
        showCopy={false}
        showCta={false}
        showCaption={false}
        contentSlot={heroForm}
        backgroundColor="#F2F3F2"
      />

      <Footer />
    </div>
  );
};

export default StudentClub;
